export const ADD = 'notifications/ADD';
export const REMOVE = 'notifications/REMOVE';
export const CLEAR = 'notifications/CLEAR';

export const ERROR = 'error';
export const INFO = 'info';

export const add = (text, notificationType = INFO) => ({
  type: ADD,
  text,
  notificationType
});
export const remove = (notificationId) => ({
  type: REMOVE,
  notificationId
});
export const clear = () => ({
  type: CLEAR
});
